<app-nav></app-nav>
<section class="polyclinic">
  <app-click-to-call></app-click-to-call>
  <div class="container">
    <div class="col">
      <div class="claim-pop text-center">
        <img src="../../assets/images/Cosmetic_Surgery_Image.png">
      </div>
      <p class="text-center"><b>Cosmetic Surgery</b></p>
      <p class="text-center"><span class="sub-title"></span> Get free video consultation with a reputed surgeon. Select the type of surgery below.
       <br> We will schedule a call with you, based on the availability of the Surgeon.
      </p>
      <p class="text-center">Following benefits are included in case of surgery in preferred partner hospitals</p>
      <p class="text-center" style="color:#F15A23"><span class="sub-title">*</span>available in selected cities</p>
      <div class="row mb-3" style="display: flex; justify-content: center;">
        <div class="Rectangle-2076 col-md-3"><img src="../../assets/images/Free room upgrade.svg" class="mr-1"><span>Free room upgrade</span></div>
        <div class="Rectangle-2076 col-md-3"><img src="../../assets/images/Cashless insurance claims.svg" class="mr-1"><span>Not payable under insurance</span></div>
        <div class="Rectangle-2076 col-md-4"><img src="../../assets/images/Discounts.svg" class="mr-1"><span>Discounts on non-medical expenses</span></div>
      </div>
      <div class="ml-4 mr-4">
        <h6 class="spec-cat"><b>Cosmetic Surgery</b></h6>
        <div class="text-center mb-4 ">
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Lasik Surgery');">Lasik Surgery</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Lasik Surgery'" (click)="confirmAppointment('Lasik Surgery')" [disabled]="this.disable">Confirm</button>
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Tooth Aligners');">Tooth Aligners</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Tooth Aligners'" (click)="confirmAppointment('Tooth Aligners')" [disabled]="this.disable">Confirm</button>
          <button class="btn btn-bordered-blue mt-2" (click)="bookAppointment('Liposuction');">Liposuction</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Liposuction'" (click)="confirmAppointment('Liposuction')" [disabled]="this.disable">Confirm</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="thankyou" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body claim-pop text-center mt-4">
          <img
            src="../../assets/images/Thank you Doctor Illustrator.svg">
        </div>
        <div class="text-center ml-4 mr-4">
          <p>Thank you!</p>
          <p>
            We will schedule a counsellor for an appointment with the Surgeon</p>
        </div>
        <div class="text-center ml-4 mr-4 mb-4">
          <button type="button" class="btn btn-blue" data-dismiss="modal" routerLink="/home">Done</button>
        </div>
      </div>
    </div>
  </div>
</section>

<div id="spinner" [hidden]="!loading">
  <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</div>